import axios from 'utils/axios';

export const getLogs = async (data) => {
    const result = await axios.get('logs/', {
        params: data
    });
    return result.data;
};
